<i18n
  src="@/locales/components/views/service_provider/services/container_op/uploader_attachment.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container_service_attachment.yml" lang="yaml"></i18n>
<template>
  <div>
    <div class="flex">
      <upload-button @click.prevent="open = true" :label="$t('labels.title')" />
    </div>
    <TransitionRoot as="template" :show="open">
      <Dialog
        as="div"
        class="fixed z-10 inset-0 overflow-y-auto"
        @close="close"
      >
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <DialogOverlay
              class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            />
          </TransitionChild>

          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div class="panel-modal">
              <div class="panel-modal-close">
                <button type="button" class="panel-modal-close" @click="close">
                  <span class="sr-only">Close</span>
                  <i class="h-6 w-6 fa-solid fa-xmark"></i>
                </button>
              </div>

              <div class="panel-header-title">
                {{ $t("labels.title") }}
              </div>

              <alert-danger :errors_data="std_err" />

              <div class="panel-modal-body">
                <div class="space-y-8 divide-gray-200">
                  <div class="px-8">
                    <div
                      class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                    >
                      <div class="sm:col-span-6">
                        <label class="label-form">
                          {{
                            $t(
                              "model.container_service_attachment.service_template_file"
                            )
                          }}
                        </label>
                        <div class="mt-1">
                          <select-form
                            v-if="files.length > 1"
                            :options="files"
                            v-model="file_id"
                          />
                          <p v-else-if="files.length == 1">
                            {{ files[0].name }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="flex items-center justify-center w-full">
                      <label
                        @dragover="dragover"
                        @dragleave="dragleave"
                        @drop="drop"
                        for="dropzone-file"
                        class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                      >
                        <div
                          class="flex flex-col items-center justify-center pt-5 pb-6"
                        >
                          <i
                            :class="[
                              'fa-solid  fa-2xl w-10 h-10 mb-3 ',
                              attach?.name
                                ? 'fa-cloud-arrow-up text-lime-600'
                                : 'fa-cloud-plus text-gray-400',
                            ]"
                          ></i>
                          <p
                            v-show="!attach?.name"
                            class="mb-2 text-sm text-gray-500 dark:text-gray-400"
                          >
                            <span class="font-semibold">
                              {{ $t("labels.click_to_upload") }}
                            </span>
                            <span>{{ $t("labels.drag_and_drop_file") }}</span>
                          </p>
                          <p
                            v-show="attach?.name"
                            class="text-sm text-gray-500 dark:text-gray-400"
                          >
                            <span class="font-semibold">
                              {{ attach?.name }}
                            </span>
                          </p>
                        </div>
                        <input
                          id="dropzone-file"
                          type="file"
                          class="hidden"
                          ref="attach"
                          @change="setAttach"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="panel-modal-footer">
                <success-button
                  v-if="!charging_submit"
                  @click.prevent="submit()"
                  :label="$t('labels.upload_button')"
                />
                <success-button-processing
                  v-else
                  :label="$t('labels.upload_button')"
                />
                <span class="space-actions"></span>
                <white-button
                  class="panel-modal-footer-close"
                  @click.prevent="close"
                  :label="$t('labels.close_button')"
                />
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
    <div />
  </div>
</template>

<script>
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

export default {
  name: "UploaderAttachment",
  components: {
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
  },
  props: ["files", "newAttach"],
  data() {
    return {
      open: false,
      attach: null,
      container: null,
      file_id: null,
      charging_submit: false,
    };
  },
  computed: {
    can_send: function () {
      return this.attach && this.file_id;
    },
    save_link_class: function () {
      let basic_class = "btn-main";
      if (this.can_send) return basic_class;
      return `${basic_class}  opacity-50 cursor-not-allowed`;
    },
  },
  watch: {
    files: {
      handler: function (files) {
        if (!files) return;

        if (files.length == 1) {
          this.file_id = files[0].id;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  emits: ["new"],
  methods: {
    close: function () {
      if (this.charging_submit) return;

      this.removeAttach();
      this.file_id = null;
      this.open = false;
    },
    submit: async function () {
      this.charging_submit = true;
      if (!this.attach) return;
      let attach = await this.newAttach({
        service_template_file_id: this.file_id,
        attach: this.attach,
      });
      if (attach) this.$emit("new", attach);
      this.charging_submit = false;
      this.close();
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("bg-lime-200")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-lime-200");
      }
    },
    dragleave(event) {
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-lime-200");
    },
    drop(event) {
      event.preventDefault();
      let files = event.dataTransfer.files;
      this.attach = files[0];
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-lime-200");
    },
    removeAttach: function () {
      this.attach = null;
    },
    setAttach: function () {
      if (!this.$refs.attach) return;
      this.attach = this.$refs.attach.files[0];
    },
  },
};
</script>
